import { createRoute } from '@tanstack/react-router';

import { clientRoute } from '../../../../../pages/client/route';

export const processIncomingMobilityRoute = createRoute({
	getParentRoute: () => clientRoute,
	path: 'process-incoming-mobility/$mobilityUuid',
});
